<script>
  // import About from "../components/About.svelte"

  // import { cipher, decipher } from "../etc/myCipher.js"
  import AesCtr from "../etc/aes-ctr.js"

  // import AesCtr from "//cdn.jsdelivr.net/gh/chrisveness/crypto@latest/aes-ctr.js"

  document.addEventListener("DOMContentLoaded", function (event) {
    document.querySelector("#password").oninput = function () {
      const password = document.querySelector("#password").value
      const plaintxt = document.querySelector("#plaintxt").value
      const t1 = performance.now()
      const encrtext = AesCtr.encrypt(plaintxt, password, 256)
      const t2 = performance.now()
      document.querySelector("#encrtext").value = encrtext
      document.querySelector("#time-encrypt").value =
        (t2 - t1).toFixed(3) + "ms"
      document.querySelector("#encrtext").oninput() // trigger decrypt
    }

    document.querySelector("#plaintxt").oninput = function () {
      const password = document.querySelector("#password").value
      const plaintxt = document.querySelector("#plaintxt").value
      const t1 = performance.now()
      const encrtext = AesCtr.encrypt(plaintxt, password, 256)
      const t2 = performance.now()
      document.querySelector("#encrtext").value = encrtext
      document.querySelector("#time-encrypt").value =
        (t2 - t1).toFixed(3) + "ms"
      document.querySelector("#encrtext").oninput() // trigger decrypt
    }

    document.querySelector("#encrtext").oninput = function () {
      try {
        const password = document.querySelector("#password").value
        const encrtext = document.querySelector("#encrtext").value
        const t1 = performance.now()
        const decrtext = AesCtr.decrypt(encrtext, password, 256)
        const t2 = performance.now()
        document.querySelector("#decrtext").value = decrtext
        document.querySelector("#time-decrypt").value =
          (t2 - t1).toFixed(3) + "ms"
      } catch (e) {
        document.querySelector("#decrtext").value = ""
        document.querySelector("#time-decrypt").value = e.message
      }
    }

    document.querySelector("#password").oninput() // trigger initial hash
  })

  //   // To create a cipher
  //   const myCipher = cipher("mySecretSalt")
  //   const myDecipher = decipher("mySecretSalt")

  //   let question = ""
  //   let cQuestion = ""
  //   let dQuestion = ""

  //   function generateCipher(str) {
  //     cQuestion = myCipher(str)
  //     dQuestion = myDecipher(cQuestion)
  //   }

  //   //Then cipher any text:
  //   myCipher("the secret string") // --> "7c606d287b6d6b7a6d7c287b7c7a61666f"

  //   //To decipher, you need to create a decipher and use it:
  //   myDecipher("7c606d287b6d6b7a6d7c287b7c7a61666f") // --> 'the secret string'
</script>

<!-- <div class="my-cipher">
  <h4>Testing myCipher</h4>
  <label for="question-string">Enter Question</label>
  <input type="text" bind:value={question} />
  <button class="btn" on:click={() => generateCipher(question)}>Submit</button>

  <h4>Encrypted Question</h4>
  <div class="question-result">{cQuestion}</div>

  <h4>Decipher Question</h4>
  <div class="decipher-result">{dQuestion}</div>
</div> -->

<form>
  <fieldset>
    <legend>Functional demo</legend>
    <ul>
      <li>
        <label for="password">Password</label>
        <input
          type="text"
          name="password"
          id="password"
          value="【XiYi 習易網】"
          class="w12"
        />
      </li>
      <li>
        <label for="plaintxt">Plaintext</label>
        <textarea
          name="plaintxt"
          id="plaintxt"
          class="width-full"
          placeholder="Please enter some text to be encrypted."
        />
      </li>
      <li>
        <label>Encrypted text</label>
        <textarea name="encrtext" id="encrtext" class="width-full" />
        <output class="small grey" id="time-encrypt" />
      </li>
      <li>
        <label>Decrypted text</label>
        <textarea name="decrtext" id="decrtext" readonly class="width-full" />
        <output class="small grey" id="time-decrypt" />
      </li>
    </ul>
  </fieldset>
</form>
